import clsx from 'clsx';
import React, { forwardRef, useMemo } from 'react';
import { Box } from '../Box';
import { ListItem } from './ListItem';
import { ListContext } from './ListContext';
import './List.css';
const ListComponent = forwardRef(function List(props, ref) {
    const { children, ordered, className, icon, iconColor, dense, role = 'list', unstyled, avatar = false, ...rest } = props;
    return (React.createElement(ListContext.Provider, { value: useMemo(() => ({ icon, iconColor, avatar }), [icon, iconColor, avatar]) },
        React.createElement(Box.Restricted, { ...rest, role: role, className: clsx('mollie-ui-list', {
                'mollie-ui-list--ordered': !!ordered,
                'mollie-ui-list--dense': !!dense,
                'mollie-ui-list--avatar': !!avatar,
                'mollie-ui-list--unstyled': !!unstyled,
            }, className), elementType: ordered ? 'ol' : 'ul', ref: ref }, children)));
});
ListComponent.displayName = 'List';
export const List = Object.assign({}, ListComponent, {
    Item: ListItem,
});
//# sourceMappingURL=List.js.map